// extracted by mini-css-extract-plugin
module.exports = {"form":"RecoveryPassForm_form__2fk97 form_form__a6yyo","link":"RecoveryPassForm_link__3t279 LinkNative_link__hGO0Z","spanAvatar":"RecoveryPassForm_spanAvatar__ejPYo"};